const initialStatus = {
  loading: false,
  success: false,
  error: false,
  message: null,
}

const initialState = { conversations: {} }

const tabListReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CONVERSATION_TABS_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action?.payload?.action]: {
            ...initialStatus,
            ...action?.payload?.value,
          },
        },
      }
    case 'SET_CONVERSATION_TABS':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action?.payload?.chatId]: action?.payload?.data,
        },
      }
    case 'DELETE_TAB': {
      const { chatId, tabId } = action?.payload ?? {}
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: state.conversations?.[chatId].filter(
            (e) => e.tabId !== tabId
          ),
        },
      }
    }
    case 'DELETE_CONVERSATION_TAB_LIST': {
      const { chatId } = action?.payload ?? {}
      const { [chatId]: chatDeleted, ...newChats } = state.conversations
      return {
        ...state,
        conversations: newChats,
      }
    }

    default:
      return state
  }
}

export default tabListReducer
